import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';

export const sortArrayBy = (field, array) => {
    if (array.length < 2) { return array; }
    const sortMap = array.map((e, id) => ({id, field: `${e[field] || ''}`})).sort( (a, b) => a.field.localeCompare( b.field ));
    return sortMap.map( ({id}) => array[id]);
};

const sanitise = ({enrolments, assignments, ...rest}) => ({
    enrolments: Number(enrolments) || 0,
    assignments: Number(assignments) || 0,
    ...rest
});

const reduceCourseStats = (state, action) => {
    switch (action.type) {
        case ActionTypes.COURSE_ENROLMENT_STATS_SUCCESS:
            return {
                ...state,
                [action.payload.courseId]: action.data.map(sanitise),
            };
        default:
            return state;
    }
};

class CourseEnrolmentStatStore extends ReduceStore {

    getInitialState() {
        return {
            isFetching: 0,
            courseId: {},
        };
    }

    isFetching() {
        return this.getState().isFetching > 0;
    }
    getStats(groupBy) {
        return this.getState()[ groupBy ] || [];
    }

    getCourseStats(courseId) {
        return this.getState().courseId[courseId] || [];
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.COURSE_ENROLMENT_STATS_REQUEST:
                return {...state, isFetching: state.isFetching + 1};

            case ActionTypes.COURSE_ENROLMENT_STATS_SUCCESS:
                const { groupBy } = action.payload;
                if (groupBy === 'courseId') {
                    return {
                        ...state,
                        courseId: reduceCourseStats(state.courseId || {}, action),
                        isFetching: state.isFetching - 1
                    };
                } else {
                    return {
                        ...state,
                        [groupBy]: action.data.map(sanitise),
                        isFetching: state.isFetching - 1
                    };
                }

            case ActionTypes.COURSE_ENROLMENT_STATS_FAILURE:
                return {...state, isFetching: state.isFetching - 1};

            default:
                return state;
        }
    }
}

export default new CourseEnrolmentStatStore(CentricDispatcher);
